import { HTMLAttributes } from "react";
import { Panel, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

export interface StaticSetupPanelProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  stepNumber?: number;
  title: string | React.ReactNode;
  description?: string;
}

export const StaticSetupPanel = ({ stepNumber, title, description, children, className, ...props }: StaticSetupPanelProps) => {
  return (
    <Panel className={clsx("!p-0", className)} data-panel-step={stepNumber} {...props}>
      {/* Header */}
      <div className="border-b border-neutral-mid-gray px-5 py-4">
        <div className="flex items-center gap-2.5">
          {stepNumber && (
            <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-neutral-mid-gray">
              <Typography variant="title" className="text-neutral-black">
                {stepNumber}
              </Typography>
            </div>
          )}
          <div className="flex flex-1 flex-col gap-1">
            <Typography variant="title" className="text-neutral-black">
              {title}
            </Typography>
            {description && (
              <Typography variant="paragraph" className="text-neutral-black">
                {description}
              </Typography>
            )}
          </div>
        </div>
      </div>

      {/* Content - Always visible */}
      <div className="flex flex-col gap-3 p-4">{children}</div>
    </Panel>
  );
};
